(function () {
  var SELECTOR = '[data-wheel-promo]';
  var TEST_EMAIL = 'marketing@theflavorgang.ca';

  var PRIZES = [
    {
      label: '$50 Gift Card',
      code: '',
      angle: 22.5,
      weight: 0,
      note: 'You won a $50 gift card. Please submit your information so our team can verify your prize.',
      requiresClaim: true,
      claimTag: 'wheel-prize-50-gift-card',
      allowSpinAgain: false,
      buttonLabel: 'Continue to shop'
    },
    {
      label: '$25 Gift Card',
      code: '',
      angle: 67.5,
      weight: 0,
      note: 'You won a $25 gift card. Please submit your information so our team can verify your prize.',
      requiresClaim: true,
      claimTag: 'wheel-prize-25-gift-card',
      allowSpinAgain: false,
      buttonLabel: 'Continue to shop'
    },
    {
      label: '5% Off',
      code: 'TFG5OFF',
      angle: 112.5,
      weight: 400,
      note: 'You won 5% off. The discount code will be automatically applied at checkout.',
      requiresClaim: false,
      claimTag: 'wheel-prize-5-off',
      allowSpinAgain: false,
      buttonLabel: 'Shop with discount applied'
    },
    {
      label: '15% Off',
      code: 'TFG15OFF',
      angle: 157.5,
      weight: 175,
      note: 'You won 15% off. The discount code will be automatically applied at checkout.',
      requiresClaim: false,
      claimTag: 'wheel-prize-15-off',
      allowSpinAgain: false,
      buttonLabel: 'Shop with discount applied'
    },
    {
      label: '30% Off',
      code: 'TFG30OFF',
      angle: 202.5,
      weight: 25,
      note: 'You won 30% off. The discount code will be automatically applied at checkout.',
      requiresClaim: false,
      claimTag: 'wheel-prize-30-off',
      allowSpinAgain: false,
      buttonLabel: 'Shop with discount applied'
    },
    {
      label: '50% Off',
      code: 'TFG50OFF',
      angle: 247.5,
      weight: 0,
      note: 'You won 50% off. The discount code will be automatically applied at checkout.',
      requiresClaim: false,
      claimTag: 'wheel-prize-50-off',
      allowSpinAgain: false,
      buttonLabel: 'Shop with discount applied'
    },
    {
      label: 'Spin Again',
      code: '',
      angle: 292.5,
      weight: 375,
      note: 'You landed on Spin Again. Please spin the wheel again to receive your prize.',
      requiresClaim: false,
      claimTag: 'wheel-prize-spin-again',
      allowSpinAgain: true,
      buttonLabel: 'Spin again'
    },
    {
      label: '1 Free Bag BOGz',
      code: '',
      angle: 337.5,
      weight: 25,
      note: 'You won one free bag of BOGz. Please submit your information so our team can verify your prize.',
      requiresClaim: true,
      claimTag: 'wheel-prize-free-bogz',
      allowSpinAgain: false,
      buttonLabel: 'Continue to shop'
    }
  ];

  function normalizePrize(prize) {
    return {
      label: prize.label || 'Prize',
      code: prize.code || '',
      angle: Number(prize.angle || 0),
      weight: Math.max(0, Number(prize.weight || 1)),
      note: prize.note || '',
      requiresClaim: Boolean(prize.requiresClaim),
      claimTag: prize.claimTag || '',
      allowSpinAgain: Boolean(prize.allowSpinAgain),
      buttonLabel: prize.buttonLabel || 'Shop now'
    };
  }

  function slugify(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function pickPrize(prizes) {
    var totalWeight = prizes.reduce(function (sum, prize) {
      return sum + Math.max(0, prize.weight);
    }, 0);

    if (!totalWeight) {
      return prizes[Math.floor(Math.random() * prizes.length)];
    }

    var random = Math.random() * totalWeight;

    for (var i = 0; i < prizes.length; i += 1) {
      random -= Math.max(0, prizes[i].weight);

      if (random <= 0) {
        return prizes[i];
      }
    }

    return prizes[prizes.length - 1];
  }

  function getDiscountUrl(rootUrl, code, redirect) {
    var cleanRoot = rootUrl || '/';

    if (cleanRoot.charAt(cleanRoot.length - 1) !== '/') {
      cleanRoot += '/';
    }

    if (!code) {
      return redirect || cleanRoot;
    }

    return cleanRoot + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect || '/collections/all');
  }

  function sendClaimWebhook(url, payload) {
    if (!url) return;

    var body = JSON.stringify(payload);

    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });

        if (navigator.sendBeacon(url, blob)) {
          return;
        }
      }
    } catch (error) {}

    try {
      fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        keepalive: true,
        headers: {
          'Content-Type': 'text/plain;charset=UTF-8'
        },
        body: body
      }).catch(function () {});
    } catch (error) {}
  }

  function getLocalValue(key) {
    try {
      return localStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function setLocalValue(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {}
  }

  function getStoredEmail(root, key) {
    var emailInput = root.querySelector('.wheel-promo__form input[type="email"]');
    var email = emailInput && emailInput.value ? emailInput.value.trim() : '';

    if (email) {
      return email;
    }

    return getLocalValue(key + ':email');
  }

  function initThemeOnlyGuards() {
    if (window.__tfgWheelPromoGuardsReady) return;

    window.__tfgWheelPromoGuardsReady = true;

    function insideWheel(event) {
      return event.target && event.target.closest && event.target.closest(SELECTOR);
    }

    function isEditable(target) {
      if (!target) return false;

      var tag = (target.tagName || '').toLowerCase();

      return tag === 'input' || tag === 'textarea' || tag === 'select' || target.isContentEditable;
    }

    document.addEventListener('contextmenu', function (event) {
      if (insideWheel(event)) {
        event.preventDefault();
      }
    }, true);

    document.addEventListener('dragstart', function (event) {
      if (insideWheel(event)) {
        event.preventDefault();
      }
    }, true);

    document.addEventListener('selectstart', function (event) {
      if (insideWheel(event) && !isEditable(event.target)) {
        event.preventDefault();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (!insideWheel(event)) return;

      var key = String(event.key || '').toLowerCase();

      var blocked =
        key === 'f12' ||
        ((event.ctrlKey || event.metaKey) && ['u', 's', 'p'].indexOf(key) !== -1) ||
        ((event.ctrlKey || event.metaKey) && event.shiftKey && ['i', 'j', 'c'].indexOf(key) !== -1);

      if (blocked) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
  }

  function initWheel(root) {
    if (!root || root.dataset.wheelReady === 'true') return;

    initThemeOnlyGuards();

    var wheel = root.querySelector('[data-wheel-image]');
    var spinButton = root.querySelector('[data-wheel-spin]');
    var lockedNote = root.querySelector('[data-wheel-locked-note]');
    var resultTitle = root.querySelector('[data-wheel-result-title]');
    var resultNote = root.querySelector('[data-wheel-result-note]');
    var shopLink = root.querySelector('[data-wheel-shop-link]');
    var successNode = root.querySelector('[data-wheel-form-success]');
    var emailForm = root.querySelector('.wheel-promo__form');
    var claimWrap = root.querySelector('[data-wheel-claim]');
    var claimForm = root.querySelector('[data-wheel-claim-form]');
    var claimName = root.querySelector('[data-wheel-claim-name]');
    var claimEmail = root.querySelector('[data-wheel-claim-email]');
    var claimPhone = root.querySelector('[data-wheel-claim-phone]');
    var claimSuccess = root.querySelector('[data-wheel-claim-success]');
    var claimPrize = root.querySelector('[data-wheel-claim-prize]');

    var prizes = PRIZES.map(normalizePrize).filter(function (prize) {
      return prize.weight > 0;
    });

    if (!wheel || !spinButton || !prizes.length) return;

    var requireEmail = root.dataset.requireEmail === 'true';
    var oneSpin = root.dataset.oneSpin === 'true';
    var storeKey = root.dataset.storeKey || 'tfg-wheel-promo';
    var rootUrl = root.dataset.rootUrl || '/';
    var defaultLink = root.dataset.defaultLink || '/collections/all';
    var claimWebhookUrl = root.dataset.claimWebhook || '';
    var currentRotation = 0;
    var storedEmail = String(getLocalValue(storeKey + ':email') || '').trim().toLowerCase();
    var hasStoredEmail = Boolean(storedEmail);
    var isTestMode = storedEmail === TEST_EMAIL;
    var isUnlocked = !requireEmail || Boolean(successNode) || hasStoredEmail;
    var isSpinning = false;
    var originalSpinLabel = spinButton.textContent;
    var spinningLabel = root.dataset.spinningLabel || 'Spinning...';
    var currentPrize = null;

    function pickTestPrize(testPrizes) {
      var testIndexKey = storeKey + ':test-index';
      var index = Number(getLocalValue(testIndexKey) || 0);
      var prize = testPrizes[index % testPrizes.length];

      setLocalValue(testIndexKey, String(index + 1));

      return prize;
    }

    function setUnlocked(value) {
      isUnlocked = Boolean(value);
      root.classList.toggle('is-unlocked', isUnlocked);
      spinButton.disabled = !isUnlocked;

      if (lockedNote) {
        lockedNote.hidden = isUnlocked;
      }
    }

    function closeClaimModal() {
      if (claimWrap) {
        claimWrap.hidden = true;
      }

      root.classList.remove('requires-claim');
      document.documentElement.classList.remove('wheel-promo-modal-open');
    }

    function openClaimModal(prize) {
      if (!claimWrap || !claimForm) return;

      var prizeSlug = prize.claimTag || ('wheel-prize-' + slugify(prize.label));

      claimForm.classList.remove('is-claimed');

      if (claimSuccess) {
        claimSuccess.hidden = true;
      }

      if (claimPrize) {
        claimPrize.value = prizeSlug;
      }

      if (claimEmail && !claimEmail.value) {
        claimEmail.value = getStoredEmail(root, storeKey);
      }

      claimWrap.hidden = false;
      root.classList.add('requires-claim');
      document.documentElement.classList.add('wheel-promo-modal-open');

      window.setTimeout(function () {
        if (claimName) {
          claimName.focus();
        }
      }, 150);
    }

    function showResult(prize, restoreOnly) {
      if (!prize) return;

      currentPrize = prize;

      var redirect = defaultLink || '/collections/all';
      var code = prize.code || '';
      var discountUrl = getDiscountUrl(rootUrl, code, redirect);

      root.classList.add('has-result');
      root.classList.toggle('has-auto-discount', Boolean(code) && !prize.requiresClaim);

      if (resultTitle) {
        resultTitle.textContent = prize.label;
      }

      if (resultNote) {
        resultNote.textContent = prize.note || (code ? 'The discount code will be automatically applied at checkout.' : 'Please follow the instructions to claim your prize.');
      }

      if (shopLink) {
        if (prize.allowSpinAgain) {
          shopLink.href = '#spin-again';
          shopLink.textContent = prize.buttonLabel || 'Spin again';
          shopLink.setAttribute('data-result-spin-again', 'true');
        } else {
          shopLink.removeAttribute('data-result-spin-again');
          shopLink.href = code && !prize.requiresClaim ? discountUrl : redirect;

          if (prize.requiresClaim) {
            shopLink.textContent = prize.buttonLabel || 'Continue to shop';
          } else {
            shopLink.textContent = code ? (prize.buttonLabel || 'Shop with discount applied') : 'Shop now';
          }
        }
      }

      if (prize.requiresClaim) {
        var claimed = false;

        if (!isTestMode) {
          try {
            var savedClaim = JSON.parse(getLocalValue(storeKey + ':claimed') || 'null');
            claimed = Boolean(savedClaim && savedClaim.prize === prize.label);
          } catch (error) {}
        }

        if (!claimed) {
          openClaimModal(prize);
        } else {
          closeClaimModal();
        }
      } else {
        closeClaimModal();
      }

      if (isTestMode) {
        spinButton.disabled = false;
        spinButton.textContent = 'Test next prize';
        root.classList.remove('is-spinning');
        return;
      }

      if (prize.allowSpinAgain && !restoreOnly) {
        spinButton.disabled = false;
        spinButton.textContent = prize.buttonLabel || 'Spin again';
        root.classList.remove('is-spinning');
      } else {
        spinButton.disabled = true;

        if (oneSpin && !restoreOnly) {
          setLocalValue(storeKey, JSON.stringify(prize));
        }
      }
    }

    function restoreSavedResult() {
      if (!oneSpin) return false;

      try {
        var saved = getLocalValue(storeKey);

        if (!saved) return false;

        var prize = normalizePrize(JSON.parse(saved));

        showResult(prize, true);
        setUnlocked(true);
        spinButton.disabled = true;

        return true;
      } catch (error) {
        return false;
      }
    }

    if (emailForm) {
      emailForm.addEventListener('submit', function () {
        var emailInput = emailForm.querySelector('input[type="email"]');

        if (!emailInput || !emailInput.value) return;

        var emailValue = emailInput.value.trim();

        setLocalValue(storeKey + ':email', emailValue);

        storedEmail = emailValue.toLowerCase();
        isTestMode = storedEmail === TEST_EMAIL;
      });
    }

    if (claimForm) {
      claimForm.addEventListener('submit', function (event) {
        event.preventDefault();

        var prize = currentPrize;

        if (!prize) return;

        var name = claimName && claimName.value ? claimName.value.trim() : '';
        var email = claimEmail && claimEmail.value ? claimEmail.value.trim() : '';
        var phone = claimPhone && claimPhone.value ? claimPhone.value.trim() : '';
        var prizeSlug = prize.claimTag || ('wheel-prize-' + slugify(prize.label));
        var tags = 'wheel-promo-canada, wheel-winner, ' + prizeSlug + ', wheel-claimed';

        setLocalValue(storeKey + ':claimed', JSON.stringify({
          prize: prize.label,
          email: email,
          claimedAt: new Date().toISOString()
        }));

        if (email) {
          setLocalValue(storeKey + ':email', email);
        }

        sendClaimWebhook(claimWebhookUrl, {
          source: 'TFG Canada Wheel Promo',
          prize: prize.label,
          prizeCode: prize.code || '',
          prizeTag: prizeSlug,
          name: name,
          email: email,
          phone: phone,
          tags: tags,
          isTest: isTestMode,
          claimedAt: new Date().toISOString(),
          page: window.location.href,
          userAgent: window.navigator ? window.navigator.userAgent : ''
        });

        window.setTimeout(function () {
          if (claimSuccess) {
            claimSuccess.hidden = false;
          }

          if (claimForm) {
            claimForm.classList.add('is-claimed');
          }

          window.setTimeout(closeClaimModal, 1400);
        }, 250);
      });
    }

    if (shopLink) {
      shopLink.addEventListener('click', function (event) {
        if (shopLink.getAttribute('data-result-spin-again') === 'true') {
          event.preventDefault();

          if (!isSpinning) {
            spinButton.click();
          }
        }
      });
    }

    setUnlocked(isUnlocked);

    if (!isTestMode) {
      restoreSavedResult();
    } else {
      spinButton.disabled = false;
      root.classList.add('is-test-mode');
    }

    root.dataset.wheelReady = 'true';

    spinButton.addEventListener('click', function () {
      if (!isUnlocked || isSpinning || spinButton.disabled) return;

      var prize = isTestMode ? pickTestPrize(prizes) : pickPrize(prizes);
      var finalAngle = ((360 - (prize.angle % 360)) + 360) % 360;
      var extraSpins = 5 + Math.floor(Math.random() * 3);
      var currentMod = ((currentRotation % 360) + 360) % 360;
      var deltaToTarget = ((finalAngle - currentMod) + 360) % 360;
      var targetRotation = currentRotation + (extraSpins * 360) + deltaToTarget;

      isSpinning = true;

      root.classList.add('is-spinning');
      root.classList.remove('has-result', 'has-auto-discount', 'requires-claim');

      document.documentElement.classList.remove('wheel-promo-modal-open');

      if (claimWrap) {
        claimWrap.hidden = true;
      }

      spinButton.disabled = true;
      spinButton.textContent = spinningLabel;
      wheel.style.transform = 'rotate(' + targetRotation + 'deg)';

      currentRotation = targetRotation;

      window.setTimeout(function () {
        isSpinning = false;
        spinButton.textContent = originalSpinLabel;
        root.classList.remove('is-spinning');
        showResult(prize, false);
      }, 5600);
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initWheel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initWheel(event.target.querySelector(SELECTOR));
  });
})();